/**
 * Runtime Stripe / Kjuup.io visibility helpers.
 *
 * Personal Stripe for regular Kjuup users is on when the global
 * AppSettings.stripeFeatureEnabled flag is on OR the superadmin enabled
 * Kjuup.io on that user (user.stripeFeatureEnabled).
 * Per-company flag (company.stripeFeatureEnabled) controls Kjuup+ billing.
 */

/**
 * Whether Stripe / Kjuup.io UI should be active for this user.
 * - Kjuup+ members: company-level flag
 * - Everyone else: personal flag (global setting or per-user grant)
 */
export function isStripeFeatureActive({
  stripeFeatureEnabled,
  companyStripeFeatureEnabled,
  isKjuupPlusMember,
}) {
  if (isKjuupPlusMember) {
    return !!companyStripeFeatureEnabled;
  }
  return !!stripeFeatureEnabled;
}

/**
 * Resolve flags from Redux profile + subscription slices.
 */
export function resolveStripeFlags(profile, subscription) {
  const sub = subscription || {};
  const prof = profile || {};
  // Off by default until profile/subscription status loads (or admin enables).
  const stripeFeatureEnabled =
    sub.stripeFeatureEnabled != null
      ? !!sub.stripeFeatureEnabled
      : prof.stripeFeatureEnabled != null
        ? !!prof.stripeFeatureEnabled
        : false;
  const companyStripeFeatureEnabled =
    sub.companyStripeFeatureEnabled != null
      ? !!sub.companyStripeFeatureEnabled
      : !!prof.companyStripeFeatureEnabled;
  const isKjuupPlusMember = !!sub.isKjuupPlusMember;
  return {
    stripeFeatureEnabled,
    companyStripeFeatureEnabled,
    isKjuupPlusMember,
    stripeUiEnabled: isStripeFeatureActive({
      stripeFeatureEnabled,
      companyStripeFeatureEnabled,
      isKjuupPlusMember,
    }),
  };
}
